import { NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, PlusCircle, History, BarChart3, Settings, Phone } from "lucide-react";

const NAV_ITEMS = [
  { path: "/", icon: LayoutDashboard, label: "Dashboard" },
  { path: "/heute", icon: PlusCircle, label: "Heute" },
  { path: "/vertrieb", icon: Phone, label: "Vertrieb" },
  { path: "/historie", icon: History, label: "Historie" },
  { path: "/statistiken", icon: BarChart3, label: "Statistik" },
  { path: "/einstellungen", icon: Settings, label: "Einstellung" },
];

export default function Layout({ children }) {
  const location = useLocation();

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <div className="min-h-screen bg-background flex" data-testid="app-layout">
      {/* Desktop Sidebar */}
      <aside className="hidden md:flex w-52 flex-col border-r border-border bg-card fixed h-screen">
        <div className="p-5 border-b border-border">
          <h1 className="font-heading text-lg font-bold text-white tracking-tight">100K</h1>
          <p className="text-[10px] uppercase tracking-wider text-zinc-600 mt-0.5">Punktesystem 2026</p>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              data-testid={`nav-${item.label.toLowerCase()}`}
              className={`flex items-center gap-3 px-3 py-2.5 text-sm transition-colors ${
                isActive(item.path)
                  ? "text-white bg-white/5 border-l-2 border-primary"
                  : "text-zinc-500 hover:text-zinc-300 hover:bg-white/[0.02] border-l-2 border-transparent"
              }`}
            >
              <item.icon className="h-4 w-4 flex-shrink-0" />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* Main Content */}
      <main className="flex-1 md:ml-52 pb-20 md:pb-0 min-h-screen">
        <div className="fade-in">{children}</div>
      </main>

      {/* Mobile Bottom Nav */}
      <nav
        className="fixed bottom-0 left-0 right-0 h-16 bg-black/95 backdrop-blur-sm border-t border-zinc-900 flex justify-around items-center md:hidden z-50"
        data-testid="mobile-nav"
      >
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            className={`flex flex-col items-center justify-center w-16 h-full transition-colors ${
              isActive(item.path) ? "text-primary" : "text-zinc-600"
            }`}
          >
            <item.icon className="h-5 w-5" />
            <span className="text-[9px] mt-1 tracking-wide">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
